import React from "react";
import PropTypes from "prop-types";
import style from "./quick-filters.css";
import SVGIcon from "../common/svg-icon";

function QuickFilters({ items, onClick }) {
    return (
        <div className={style.rail}>
            {items.map((item, index) => {
                return (
                    <button className={style.item} key={index} onClick={() => onClick(item)}>
                        <SVGIcon name="tick" />
                        {item}
                    </button>
                );
            })}
        </div>
    );
}

export default QuickFilters;

QuickFilters.propTypes = {
    items: PropTypes.arrayOf(PropTypes.string),
    onClick: PropTypes.func.isRequired
};

QuickFilters.defaultProps = {
    items: []
};
